import { createElement } from 'react';
import { WaterLevelPond } from '@jiaminghi/data-view-react';
const DataVWaterLevelPond = (props) => {
    const { style, ...rest } = props;
    return createElement(WaterLevelPond, { config: rest, style: style });
};
export default DataVWaterLevelPond;
